import React, { useState, useEffect, useContext } from 'react'
import { getDbVersion, getGitVersionsInformation } from 'api/pgads'
import { ErrorContext } from 'context'
import { Tabs } from 'antd'
// import { DATE_TIME_FORMAT_UI } from '../enum'
import { Title, CriteriaRow, Content, FullHeightSizer } from 'core/screen-util'
import { connect } from 'react-redux'
import { getApiTargetInfo } from 'core'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import { dateTimeCol, strCol } from '@integec/grid-tools/lib/cols'
import { rowHeaderRender } from 'core/utils'
// const columns = [
//   {
//     title: 'Project Name',
//     dataIndex: 'projectName',
//     align: 'center',
//     width: 150,
//   },
//   {
//     title: 'Git Branch',
//     dataIndex: 'git.branch',
//     width: 150,
//     ellipsis: true,
//   },
//   {
//     title: 'Commit Point',
//     dataIndex: 'git.commit.id.abbrev',
//     align: 'center',
//     width: 100,
//   },
//   {
//     title: 'Commit Point',
//     dataIndex: 'git.commit.id',
//     align: 'center',
//     width: 200,
//   },
// ]

const gridColumns = [
  {
    display: 'Project Name',
    ident: 'projectName',
    align: 'center',
    width: 200,
  },
  // {
  //   display: 'Git Branch',
  //   ident: 'git.branch',
  //   width: 320,
  //   ellipsis: true,
  // },
  {
    display: 'Commit Point',
    ident: 'git.commit.id.abbrev',
    align: 'center',
    width: 200,
  },
  {
    display: 'Commit Point',
    ident: 'git.commit.id',
    align: 'center',
    width: 400,
  },
]

const dbcolumns = [
  dateTimeCol({
    ident: 'updateDate',
    display: 'Update Date',
    width: 200,
  }),
  strCol({
    ident: 'updateVersion',
    display: 'Update Version',
    width: 400,
  }),
]

const Versions = ({ apiTargetInfo }) => {
  const [versionData, setVersionData] = useState([])

  const { setError } = useContext(ErrorContext)
  const [dbVersion, setDBVersion] = useState([])
  const [activeKey, setActiveKey] = useState('App')

  useEffect(() => {
    getGitVersionsInformation(apiTargetInfo).fork(setError, mapToArray)
    getDbVersion(apiTargetInfo).fork(setError, setDBVersion)
  }, [apiTargetInfo, setError])

  const mapToArray = dataMap => {
    const data = Object.keys(dataMap).map(temp => {
      return {
        projectName: temp
          .split('/')
          .splice(-1)
          .shift(),
        ...dataMap[temp],
      }
    })
    // eslint-disable-next-line no-undef
    const uiGit = GIT_HASH
    setVersionData([
      { projectName: 'UI', 'git.commit.id.abbrev': uiGit },
      ...data,
    ])
  }

  return (
    <>
      <CriteriaRow>
        <Title style={{ width: '170px' }}>Versions</Title>
      </CriteriaRow>
      <Content style={{ paddingTop: '24px' }}>
        <FullHeightSizer heightOffset={290}>
          {({ height, width }) => (
            <Tabs activeKey={activeKey} onChange={setActiveKey}>
              {/* <Tabs.TabPane title="App" key="App" tab="App">
                <Table
                  columns={columns}
                  dataSource={versionData}
                  size="small"
                  bordered
                  pagination={{
                    pageSize: Object.keys(versionData).length,
                    position: 'none',
                  }}
                  scroll={{ y: height - 30 }}
                />
              </Tabs.TabPane> */}
              <Tabs.TabPane title="App" key="App" tab="App Version">
                <div
                  style={{
                    height: height - 20 + 'px',
                    width: width - 50 + 'px',
                  }}
                >
                  <Grid
                    data={versionData}
                    headers={gridColumns}
                    render={virtualizedGridRenderer({
                      rowHeaderRender,
                      height: height - 40,
                      width: width - 50,
                      headerRowHeight: 30,
                    })}
                    initialSortOptions={gridColumns}
                    sortOptions={gridColumns}
                    selectionType="row"
                    selectionMode="single"
                  />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane
                title="DB Version"
                key="DB"
                tab="DB Release Version"
              >
                <div
                  style={{
                    height: height - 20 + 'px',
                    width: '700px',
                  }}
                >
                  <Grid
                    data={dbVersion}
                    headers={dbcolumns}
                    render={virtualizedGridRenderer({
                      rowHeaderRender,
                      height: height - 40,
                      width: 700,
                      headerRowHeight: 30,
                    })}
                    initialSortOptions={dbcolumns}
                    sortOptions={dbcolumns}
                    selectionType="row"
                    selectionMode="single"
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
          )}
        </FullHeightSizer>
      </Content>
    </>
  )
}
const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Versions)
